var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "divBox" }, [
    _c(
      "div",
      { staticClass: "components-container" },
      [
        _c(
          "el-form",
          { ref: "pram", attrs: { "label-width": "180px", model: _vm.pram } },
          [
            _c(
              "el-form-item",
              {
                attrs: {
                  label: "最大租赁天数",
                  prop: "maxLeaseDuration",
                  rules: [
                    {
                      required: true,
                      message: "请填写最大租赁天数",
                      trigger: ["blur", "change"],
                    },
                    {
                      type: "number",
                      min: 1,
                      message: "请输入正整数",
                      trigger: ["blur", "change"],
                    },
                  ],
                },
              },
              [
                _c("el-input", {
                  attrs: {
                    placeholder: "请输入最大租赁天数（正整数）",
                    type: "number",
                    min: "1",
                  },
                  model: {
                    value: _vm.pram.maxLeaseDuration,
                    callback: function ($$v) {
                      _vm.$set(_vm.pram, "maxLeaseDuration", _vm._n($$v))
                    },
                    expression: "pram.maxLeaseDuration",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              {
                attrs: {
                  label: "免违约金提前天数",
                  prop: "penaltyFreeDays",
                  rules: [
                    {
                      required: true,
                      message: "请填写免违约金提前天数",
                      trigger: ["blur", "change"],
                    },
                    {
                      type: "number",
                      min: 1,
                      max: 30,
                      message: "请输入1-30之间的整数",
                      trigger: ["blur", "change"],
                    },
                  ],
                },
              },
              [
                _c("el-input", {
                  attrs: {
                    placeholder: "例如：1（表示提前1天以上退款无违约金）",
                    type: "number",
                    min: "1",
                    max: "30",
                  },
                  model: {
                    value: _vm.pram.penaltyFreeDays,
                    callback: function ($$v) {
                      _vm.$set(_vm.pram, "penaltyFreeDays", _vm._n($$v))
                    },
                    expression: "pram.penaltyFreeDays",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              {
                attrs: {
                  label: "每逾期1天违约金（元）",
                  prop: "penaltyAmountPerDay",
                  rules: [
                    {
                      required: true,
                      message: "请填写每逾期1天的违约金金额",
                      trigger: ["blur", "change"],
                    },
                    {
                      type: "number",
                      min: 1,
                      message: "请输入大于0的整数",
                      trigger: ["blur", "change"],
                    },
                  ],
                },
              },
              [
                _c("el-input", {
                  attrs: {
                    placeholder: "例如：200（表示每逾期1天收取200元违约金）",
                    type: "number",
                    min: "1",
                  },
                  model: {
                    value: _vm.pram.penaltyAmountPerDay,
                    callback: function ($$v) {
                      _vm.$set(_vm.pram, "penaltyAmountPerDay", _vm._n($$v))
                    },
                    expression: "pram.penaltyAmountPerDay",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              {
                attrs: {
                  label: "违约金描述",
                  prop: "penaltyDesc",
                  rules: [
                    {
                      required: true,
                      message: "请填写违约金描述",
                      trigger: ["blur"],
                    },
                  ],
                },
              },
              [
                _c("el-input", {
                  attrs: {
                    placeholder: "请输入违约金描述（客户可见）",
                    type: "textarea",
                    rows: 6,
                  },
                  model: {
                    value: _vm.pram.penaltyDesc,
                    callback: function ($$v) {
                      _vm.$set(_vm.pram, "penaltyDesc", $$v)
                    },
                    expression: "pram.penaltyDesc",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              {
                attrs: {
                  label: "租赁规则",
                  prop: "leaseRules",
                  rules: [
                    {
                      required: true,
                      message: "请填写租赁规则",
                      trigger: ["blur", "change"],
                    },
                  ],
                },
              },
              [
                _c("Tinymce", {
                  model: {
                    value: _vm.pram.leaseRules,
                    callback: function ($$v) {
                      _vm.$set(_vm.pram, "leaseRules", $$v)
                    },
                    expression: "pram.leaseRules",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.$emit("close-dialog")
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "hasPermi",
                        rawName: "v-hasPermi",
                        value: ["admin:product:update"],
                        expression: "['admin:product:update']",
                      },
                    ],
                    attrs: { type: "primary", loading: _vm.loading },
                    on: {
                      click: function ($event) {
                        return _vm.handerSubmit("pram")
                      },
                    },
                  },
                  [_vm._v("\n          保存配置\n        ")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }